/**
 *    App - Helper
 */

(function ($) {
  Drupal.behaviors.appHelper = {
    attach() {
      Drupal.behaviors.appHelper.mouseVsKeyboard();
      Drupal.behaviors.appHelper.getScrollBarWidth();
    },

    mouseVsKeyboard() {
      // adding class by keyboard focus
      const $target = $(document.body);
      const cssClass = 'vb-keyboard-focus';

      $target.on('keydown', (e) => {
        if (e.keyCode === 9 && !$target.hasClass(cssClass)) {
          $target.addClass(cssClass);
          $(window).one('mousemove', () => {
            $target.removeClass(cssClass);
          });
        }
      });
    },

    getScrollBarWidth() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    },
  };
}(jQuery));
